"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {
      width: 800,
      textAlign: 'left',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.28)',
      borderRadius: 4
    },
    title: {
      padding: '22px 30px 0px 30px'
    },
    content: {
      margin: '16px 0px 32px 0px',
      padding: '0px 30px 0px 30px',
      '& > &': {
        marginBottom: 0,
        padding: '0 0'
      }
    },
    actions: {
      margin: '0px 30px 0px 30px',
      padding: '0 0',
      '& button': {
        marginBottom: 30,
        padding: '8px 16px'
      },
      '& button:first-of-type': {
        marginRight: 10
      }
    }
  };
};

exports.default = _default;